/**
 * Module Client #03 — Mes contrats
 * Source : Guide_Client · Chapitre 3.1.2
 */
const moduleClientContrats = {
  id: 'client-mes-contrats',
  population: 'client',
  order: 3,
  category: 'Opérations',
  title: 'Mes contrats',
  subtitle: 'Signer, suivre et exploiter vos contrats-cadres avec Baobab',
  icon: 'FileText',
  duration: '20 min',
  level: 'Intermédiaire',
  audience: 'Décideurs PME / Direction logistique',
  slides: [
    { type: 'cover', eyebrow: 'Module 03 — Client', title: 'Mes contrats', subtitle: 'Sécuriser vos flux récurrents avec un contrat-cadre', icon: 'FileText', duration: '20 min', audience: 'Décideurs', level: 'Intermédiaire' },
    { type: 'intro', title: 'Objectifs', intro: 'Un contrat-cadre engage un volume mensuel/annuel contre un tarif négocié et des SLA. Ce module vous aide à les piloter.', objectives: [
      'Comprendre la différence Spot vs Contrat',
      'Consulter un contrat actif et ses runs (opérations récurrentes)',
      'Suivre la consommation vs engagement contractuel',
      'Anticiper l\'expiration (renouvellement à J-60)',
      'Demander un avenant en cas d\'évolution',
    ]},
    { type: 'concept', eyebrow: 'Vocabulaire', icon: 'BookOpen', title: 'Anatomie d\'un contrat-cadre',
      lede: 'Un contrat comporte plusieurs blocs clés :',
      bullets: [
        '📋 Périmètre : trajets, types de véhicules, marchandises couvertes',
        '📊 Volume : nombre min/max d\'opérations par mois',
        '💰 Tarif : grille négociée (souvent dégressive selon volume)',
        '⏱️ SLA : délai de livraison, taux de service, pénalités',
        '📅 Durée : 6, 12, 24 mois — avec clauses de renouvellement automatique',
      ],
      note: 'Tout dépassement du volume max est facturé au tarif spot, pas au tarif contrat.',
    },
    { type: 'steps', title: 'Consulter votre contrat actif', steps: [
      { title: 'Menu "Mes contrats"', detail: 'Liste de tous vos contrats (actifs, expirés, brouillons).' },
      { title: 'Cliquer sur le contrat', detail: 'Vue détaillée avec onglets : Conditions, Runs, Performance.' },
      { title: 'Onglet "Runs"', detail: 'Liste des opérations exécutées dans le cadre du contrat.' },
      { title: 'Onglet "Performance"', detail: 'KPIs : taux de service, volume cumulé, % d\'atteinte engagement.' },
    ]},
    { type: 'comparison', title: 'Spot vs Contrat', do: [
      'Contrat : tarif optimisé pour les flux récurrents (-15 à -30 %)',
      'Contrat : véhicules réservés selon planning',
      'Contrat : SLA garantis avec pénalités contractuelles',
      'Contrat : facturation mensuelle groupée (1 facture/mois)',
    ], dont: [
      'Spot : flexibilité totale pour les besoins ponctuels',
      'Spot : pas d\'engagement de volume',
      'Spot : tarification à la demande (peut être plus chère)',
      'Spot : facture par opération',
    ]},
    { type: 'quiz', title: 'Quiz #1',
      question: 'Votre contrat couvre 100 opérations/mois. Vous en effectuez 130. Que se passe-t-il ?',
      options: [
        'Les 30 supplémentaires sont gratuites',
        '100 ops au tarif contrat + 30 au tarif spot',
        'Le contrat est résilié automatiquement',
        '130 ops au tarif contrat',
      ],
      answerIndex: 1,
      explanation: 'Le dépassement est facturé en spot. Pour éviter ça, demandez un avenant pour augmenter le volume.',
    },
    { type: 'takeaways', title: 'À retenir', items: [
      'Contrat-cadre = volume engagé + tarif optimisé.',
      'Suivi continu via onglet Performance.',
      'Dépassement = tarif spot ; demander avenant pour ajuster.',
      'Renouvellement à anticiper à J-60.',
    ]},
    { type: 'cta', title: 'Module 03 terminé !', actions: [
      { label: 'Voir mes contrats', href: '/mes-contrats' },
      { label: 'Catalogue', href: '/docs/client/training' },
    ]},
  ],
};
export default moduleClientContrats;
